import type { CSSProperties } from "react";

export interface SpinnerProps {
  size?: number;
  thickness?: number;
  color?: string;
  track?: string;
  style?: CSSProperties;
}

/** Circular indeterminate loading spinner (Wanted "Circular"). */
export function Spinner({
  size = 24,
  thickness,
  color = "var(--primary-normal)",
  track = "var(--fill-strong)",
  style,
}: SpinnerProps) {
  const w = typeof thickness === "number" ? thickness : Math.max(2, Math.round(size / 10));
  return (
    // <output> carries the implicit ARIA "status" role — no progressbar semantics needed for an indeterminate spinner.
    <output
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        border: `${w}px solid ${track}`,
        borderTopColor: color,
        animation: "wds-spin 0.7s linear infinite",
        boxSizing: "border-box",
        ...style,
      }}
    >
      <span className="sr-only">불러오는 중</span>
      <style>{"@keyframes wds-spin{to{transform:rotate(360deg)}}"}</style>
    </output>
  );
}

export default Spinner;
